export default __webpack_public_path__ + "static/media/honesty.d3d14a76.svg";